<template>
  <div :class="['el-toolbar', `el-toolbar--${ size }`, `el-toolbar--border-${ border }`]">
    <div class="el-toolbar-group group-left"><slot name="left"></slot></div>
    <div :class="['el-toolbar-group', 'group-title', `title-${align}`]" v-if="title">{{ title }}</div>
    <div :class="['el-toolbar-group', 'group-title', `title-${align}`]" v-if="!title"><slot></slot></div>
    <div class="el-toolbar-group group-right"><slot name="right"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'ElToolbar',
  created () {
  },
  mounted () {
  },
  data () {
    return {
    }
  },
  props: {
    size: {
      type: String,
      default: 'small'
    },
    align: {
      type: String,
      default: 'center'
    },
    title: {
      type: String
    },
    border: {
      type: String,
      default: 'none'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Toolbar.vue